<template>
  <!--  -->
  <div v-if="currentUser && (currentUser.type == 'TeleConsultant' || currentUser.type == 'NRP' || currentUser.type == 'CancelledOrder' || currentUser.type == 'ToRemind')">
    <!--  -->
    <div v-if="showButtonStart == true" class="lex-1 mb-5 mt-1 bg-gray-100 px-4 pt-3 items-center">
      <!--  -->
      <div class="bg-white w-full rounded-lg shadow">
        <!--  -->
        <div class="flex justify-center">
          <!--  -->
          <img v-if="showButtonStart == true" src="../../assets/Confirmation.svg" alt="Image" class="img-fluid" width="40%" />
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="flex justify-center">
          <!--  -->
          <div :class="showButtonStart == true ? 'flex justify-center w-1/3 mt-1 pb-20 pt-1 space-x-2' : 'flex justify-center w-1/3 mt-1  pt-1 space-x-2'">
            <!--  -->
            <div class="flex flex-col">
              <!--  -->
              <div class="mt-1 flex justify-center">
                <!--  -->
                <button class="py-1 px-6 loidingconfirm flex items-center justify-center relative bg-orange-500 rounded-lg font-bold text-white text-center transition duration-300 ease-in-out hover:bg-orange-600 focus:outline-none" :disabled="loading" v-if="showButtonStart == true" @click="startConfirmation">
                  <!--  -->
                  <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                  <!--  -->

                  <!--  -->
                  <span class="text-base" v-if="!vShow"> {{ $t('start') }} </span>
                  <!--  -->

                  <!--  -->
                  <span v-else> {{ $t('continue') }} </span>
                  <!--  -->

                  <!--  -->
                  <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                    <path id="Vector" d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <!--  -->
                </button>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
    
    <!--  -->
    <div v-if="order._id && showButtonStart == false" class="font-sans bg-grey-lighter flex flex-col min-h-screen w-full" @mousemove="move">
      <!--  -->
      <div class="content_col w-full mx-auto">
        <!--  -->
        <div class="flex-grow container mx-auto px-4">
          <!--  -->
          <div class="container mx-auto mt-12">
            <!--  -->
            <div id="gettingValuesExample">
              <!--  -->
              <div class="flip-clock">
                <!--  -->
                <span class="flip-clock__piece flip">
                  <!--  -->
                  <span class="flip-clock__card flip-card">
                    <!--  -->
                    <b class="flip-card__top hours">0</b>
                    <!--  -->
                  </span>
                  <!--  -->
                  <span class="flip-clock__slot">Hours</span>
                  <!--  -->
                </span>
                <!--  -->

                <!--  -->
                <span class="flip-clock__piece flip">
                  <!--  -->
                  <span class="flip-clock__card flip-card">
                    <!--  -->
                    <b class="flip-card__top minutes">0</b>
                    <!--  -->
                  </span>
                  <!--  -->
                  <span class="flip-clock__slot">minutes</span>
                  <!--  -->
                </span>
                <!--  -->

                <!--  -->
                <span class="flip-clock__piece flip">
                  <!--  -->
                  <span class="flip-clock__card flip-card">
                    <!--  -->
                    <b class="flip-card__top seconds">0</b>
                    <!--  -->
                  </span>
                  <!--  -->
                  <span class="flip-clock__slot">seconds</span>
                  <!--  -->
                </span>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!-- Status  -->
          <div class="card-1 p-4 flex items-center justify-center mt-8 rounded-lg" v-if="!order.shippings">
              <!--  -->
              <div class="flex items-center justify-center border-2 border-solid border-orange-400 rounded-lg overflow-hidden">
                  <!--  -->
                  <div v-if="order.status" class="text-base font-medium bg-orange-400 text-white px-4 py-1">
                      <span>{{ order.status.name }}</span>
                  </div>
                  <!--  -->

                  <!--  -->
                  <span v-if="order.sameOrderUnreached && order.sameOrderUnreached.length > 0" class="flex items-center gap-2 text-sm font-medium text-orange-400 px-2">
                      <!--  -->
                      <svg class="flex items-center justify-center fill-current" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                          <!--  -->
                          <path d="M18.48 22.926l-1.193.658c-6.979 3.621-19.082-17.494-12.279-21.484l1.145-.637 3.714 6.467-1.139.632c-2.067 1.245 2.76 9.707 4.879 8.545l1.162-.642 3.711 6.461zm-9.808-22.926l-1.68.975 3.714 6.466 1.681-.975-3.715-6.466zm8.613 14.997l-1.68.975 3.714 6.467 1.681-.975-3.715-6.467z" />
                          <!--  -->
                      </svg> 
                      <!--  -->

                      <!--  -->
                      <span>Unreached ({{ order.sameOrderUnreached.length }})</span>
                      <!--  -->
                      
                      <!--  -->
                      <span class="flex items-center gap-2" v-if="order.status && order.status.name === 'Pending' && order.lastUnreachedDate">
                          <!--  -->
                          <svg class="flex items-center justify-center fill-current" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                              <!--  -->
                              <path d="M12 12h3v2h-5v-6h2v4zm9-1h-1.07c-.251-2.006-1.218-3.792-2.647-5.093-1.283-1.166-1.228-2.247-1.856-5.907h-7.854c-.628 3.66-.573 4.741-1.856 5.907-1.67 1.52-2.717 3.701-2.717 6.124 0 2.424 1.048 4.606 2.72 6.126 1.28 1.164 1.232 2.267 1.853 5.843h7.854c.622-3.576.573-4.679 1.854-5.843 1.445-1.314 2.421-3.124 2.66-5.157h1.059v-2zm-9.5 7.5c-3.589 0-6.5-2.911-6.5-6.5s2.911-6.5 6.5-6.5 6.5 2.911 6.5 6.5-2.911 6.5-6.5 6.5z" />
                              <!--  -->
                          </svg>
                          <!--  -->

                          <!--  -->
                          <span>{{ $moment(order.lastUnreachedDate).format('yyyy-MM-DD HH: mm') }}</span>
                          <!--  -->
                      </span>
                      <!--  -->
                  </span>
                  <!--  -->

                  <!--  -->
                  <span v-if="order.remind && order.status && order.status.name === 'Pending'" class="flex items-center gap-2 text-sm font-medium text-orange-400 px-2">
                      <!--  -->
                      <svg class="flex items-center justify-center fill-current" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                          <path d="M24 12c0 6.627-5.373 12-12 12s-12-5.373-12-12h2c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10c-2.777 0-5.287 1.141-7.099 2.977l2.061 2.061-6.962 1.354 1.305-7.013 2.179 2.18c2.172-2.196 5.182-3.559 8.516-3.559 6.627 0 12 5.373 12 12zm-13-6v8h7v-2h-5v-6h-2z" />
                      </svg> 
                      <!--  -->
                      <span>Reminded (To: {{ $moment(order.remind).format('yyyy-MM-DD HH: mm') }})</span>
                      <!--  -->
                  </span>
                  <!--  -->
              </div>
          </div>
          <!-- Status -->

          <!--  -->
          <div class="card-1 w-full mt-8 rounded-lg" v-if="dataDouble.length > 0">
            <!--  -->
            <div class="bg-white flex items-center justify-between px-4 py-3 rounded-lg">
              <!--  -->
              <div class="flex items-center gap-2">
                <!--  -->
                <svg class="w-6 h-6 flex items-center justify-center text-gray-700" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <!--  -->
                  <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z" fill="currentColor"/>
                  <!--  -->
                </svg>
                <!--  -->
                <span class="text-base font-medium">{{ $t('Double orders') }}</span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <span class="text-base font-medium">({{ dataDouble.length }})</span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="w-full flex items-center justify-center p-8">
              <!--  -->
              <div class="flex flex-col items-center gap-2">
                <!--  -->
                <svg class="w-16 h-16 flex items-center justify-center text-white" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24">
                  <!--  -->
                  <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z" fill="currentColor"/>
                  <!--  -->
                </svg>
                <!--  -->

                <!--  -->
                <div class="flex flex-col items-center gap-4">
                  <!--  -->
                  <span v-if="loadingDouble">{{ $t('Checking') }} ...</span>
                  <!--  -->

                  <!--  -->
                  <span class="flex items-center gap-2" v-else>
                    <!--  -->
                    <span class="flex items-center justify-center text-base font-medium">
                      {{ $t('Number of order doubled by this phone') }} ({{ dataDouble.length}})
                    </span>
                    <!--  -->

                    <!-- -->
                    <span v-if="dataDouble.length > 0" class="flex items-center justify-center">
                      <!--  -->
                      <svg @click="$vm2.open('myModalDouble')" class="w-8 h-8 cursor-pointer text-orange-500" width="24" height="24" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <!--  -->
                        <path d="m11.998 5c-4.078 0-7.742 3.093-9.853 6.483-.096.159-.145.338-.145.517s.048.358.144.517c2.112 3.39 5.776 6.483 9.854 6.483 4.143 0 7.796-3.09 9.864-6.493.092-.156.138-.332.138-.507s-.046-.351-.138-.507c-2.068-3.403-5.721-6.493-9.864-6.493zm.002 3c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4zm0 1.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z" fill="currentColor"/>
                        <!--  -->
                      </svg>
                      <!--  -->
                    </span>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="bg-yellow-500 text-white py-1 px-2 rounded-sm">
                  <!--  -->
                  <span class="text-base text-white">{{ $t('Phone number') }}: {{ order.customer.phone }}</span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <div class="card-1 w-full mt-8 rounded-lg">
            <!--  -->
            <div class="bg-white flex items-center gap-2 px-4 py-3 rounded-lg">
              <!--  -->
              <svg class="w-6 h-6 flex items-center justify-center text-gray-700" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <!--  -->
                <path d="M13.25 7c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25.56-1.25 1.25-1.25 1.25.56 1.25 1.25zm10.75 5c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-2 0c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10 10-4.486 10-10zm-13-2v2h2v6h2v-8h-4z" fill="currentColor"/>
                <!--  -->
              </svg>
              <!--  -->
              <span class="text-base font-medium">{{ $t('detail_order') }}</span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col features md:flex-row gap-4 p-8">
              <!--  -->
              <div class="bg-white w-full lg:w-1/4 flex items-center gap-4 rounded-lg p-4 border border-solid border-orange-400">
                <!--  -->
                <div class="flex items-center justify-center">
                  <svg class="w-10 h-10 text-orange-500" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2383 2.79888C10.6243 2.88003 9.86602 3.0542 8.7874 3.30311L7.55922 3.58654C6.6482 3.79677 6.02082 3.94252 5.54162 4.10698C5.07899 4.26576 4.81727 4.42228 4.61978 4.61978C4.42228 4.81727 4.26576 5.07899 4.10698 5.54162C3.94252 6.02082 3.79677 6.6482 3.58654 7.55922L3.30311 8.7874C3.0542 9.86602 2.88003 10.6243 2.79888 11.2383C2.71982 11.8365 2.73805 12.2413 2.84358 12.6092C2.94911 12.9772 3.14817 13.3301 3.53226 13.7954C3.92651 14.2731 4.47607 14.8238 5.25882 15.6066L7.08845 17.4362C8.44794 18.7957 9.41533 19.7608 10.247 20.3954C11.0614 21.0167 11.6569 21.25 12.2623 21.25C12.8678 21.25 13.4633 21.0167 14.2776 20.3954C15.1093 19.7608 16.0767 18.7957 17.4362 17.4362C18.7957 16.0767 19.7608 15.1093 20.3954 14.2776C21.0167 13.4633 21.25 12.8678 21.25 12.2623C21.25 11.6569 21.0167 11.0614 20.3954 10.247C19.7608 9.41533 18.7957 8.44794 17.4362 7.08845L15.6066 5.25882C14.8238 4.47607 14.2731 3.92651 13.7954 3.53226C13.3301 3.14817 12.9772 2.94911 12.6092 2.84358C12.2413 2.73805 11.8365 2.71982 11.2383 2.79888ZM11.0418 1.31181C11.7591 1.21701 12.3881 1.21969 13.0227 1.4017C13.6574 1.58372 14.1922 1.91482 14.7502 2.37538C15.2897 2.82061 15.8905 3.4214 16.641 4.17197L18.5368 6.06774C19.8474 7.37835 20.8851 8.41598 21.5879 9.33714C22.311 10.2849 22.75 11.197 22.75 12.2623C22.75 13.3276 22.311 14.2397 21.5879 15.1875C20.8851 16.1087 19.8474 17.1463 18.5368 18.4569L18.4569 18.5368C17.1463 19.8474 16.1087 20.8851 15.1875 21.5879C14.2397 22.311 13.3276 22.75 12.2623 22.75C11.197 22.75 10.2849 22.311 9.33714 21.5879C8.41598 20.8851 7.37833 19.8474 6.06771 18.5368L4.17196 16.641C3.4214 15.8905 2.82061 15.2897 2.37538 14.7502C1.91482 14.1922 1.58372 13.6574 1.4017 13.0227C1.21969 12.3881 1.21701 11.7591 1.31181 11.0418C1.40345 10.3484 1.59451 9.52048 1.83319 8.48622L2.13385 7.18334C2.33302 6.32023 2.49543 5.61639 2.68821 5.05469C2.88955 4.46806 3.14313 3.9751 3.55912 3.55912C3.9751 3.14313 4.46806 2.88955 5.05469 2.68821C5.61639 2.49543 6.32023 2.33302 7.18335 2.13385L8.48622 1.83319C9.52047 1.59451 10.3484 1.40345 11.0418 1.31181ZM9.49094 7.99514C9.00278 7.50699 8.21133 7.50699 7.72317 7.99514C7.23502 8.4833 7.23502 9.27476 7.72317 9.76291C8.21133 10.2511 9.00278 10.2511 9.49094 9.76291C9.97909 9.27476 9.97909 8.4833 9.49094 7.99514ZM6.66251 6.93448C7.73645 5.86054 9.47766 5.86054 10.5516 6.93448C11.6255 8.00843 11.6255 9.74963 10.5516 10.8236C9.47766 11.8975 7.73645 11.8975 6.66251 10.8236C5.58857 9.74963 5.58857 8.00843 6.66251 6.93448ZM19.0511 10.9902C19.344 11.2831 19.344 11.7579 19.0511 12.0508L12.0721 19.0301C11.7792 19.323 11.3043 19.323 11.0114 19.0301C10.7185 18.7372 10.7185 18.2623 11.0114 17.9694L17.9904 10.9902C18.2833 10.6973 18.7582 10.6973 19.0511 10.9902Z" fill="currentColor" />
                  </svg>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex flex-col gap-1">
                  <!--  -->
                  <span class="text-xl font-medium">{{ $t('order') }}</span>
                  <!--  -->
                  <span class="text-base font-normal text-gray-600">{{ order.id }}</span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="bg-white w-full lg:w-1/4 flex items-center gap-4 rounded-lg p-4 border border-solid border-orange-400">
                <!--  -->
                <div class="flex items-center justify-center">
                  <svg class="w-8 h-8 text-orange-500" xmlns="http://www.w3.org/2000/svg" fill="#000000" width="20px" height="20px" viewBox="0 0 35 35" data-name="Layer 2" id="a866a81f-2948-4418-8bd5-1a5193c5f74e">
                    <path d="M29.545,34.75H5.455a5.211,5.211,0,0,1-5.2-5.2V8.56a5.21,5.21,0,0,1,5.205-5.2h24.09a5.21,5.21,0,0,1,5.2,5.205V29.545A5.211,5.211,0,0,1,29.545,34.75ZM5.455,5.855A2.708,2.708,0,0,0,2.75,8.56V29.545a2.709,2.709,0,0,0,2.705,2.7h24.09a2.708,2.708,0,0,0,2.7-2.7V8.56a2.707,2.707,0,0,0-2.7-2.7Z" fill="currentColor"/>
                    <path d="M33.5,17.331H1.541a1.25,1.25,0,0,1,0-2.5H33.5a1.25,1.25,0,0,1,0,2.5Z" fill="currentColor"/>
                    <path d="M9.459,9.155a1.249,1.249,0,0,1-1.25-1.25V1.5a1.25,1.25,0,0,1,2.5,0V7.905A1.25,1.25,0,0,1,9.459,9.155Z" fill="currentColor"/>
                    <path d="M25.542,9.155a1.249,1.249,0,0,1-1.25-1.25V1.5a1.25,1.25,0,0,1,2.5,0V7.905A1.25,1.25,0,0,1,25.542,9.155Z" fill="currentColor"/>
                  </svg>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex flex-col gap-1">
                  <!--  -->
                  <span class="text-xl font-medium">{{ $t('order_date') }}</span>
                  <!--  -->
                  <span class="text-base font-normal text-gray-600">{{ order.date }}</span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="bg-white w-full lg:w-1/4 flex items-center gap-4 rounded-lg p-4 border border-solid border-orange-400">
                <!--  -->
                <div class="flex items-center justify-center">
                  <svg class="w-10 h-10 text-orange-500" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                    <path d="M2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 14.5545 20.2155 16.866 18.5407 18.5407C18.2478 18.8336 18.2478 19.3085 18.5407 19.6014C18.8336 19.8943 19.3085 19.8943 19.6014 19.6014C21.5459 17.6569 22.75 14.9683 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 14.9683 2.45406 17.6569 4.3986 19.6014C4.6915 19.8943 5.16637 19.8943 5.45926 19.6014C5.75216 19.3085 5.75216 18.8336 5.45926 18.5407C3.78452 16.866 2.75 14.5545 2.75 12Z" fill="currentColor"/>
                    <path d="M6.75 12C6.75 9.1005 9.1005 6.75 12 6.75C14.8995 6.75 17.25 9.1005 17.25 12C17.25 13.45 16.6632 14.7614 15.7123 15.7123C15.4194 16.0052 15.4194 16.4801 15.7123 16.773C16.0052 17.0659 16.4801 17.0659 16.773 16.773C17.9937 15.5523 18.75 13.8638 18.75 12C18.75 8.27208 15.7279 5.25 12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 13.8638 6.00634 15.5523 7.22703 16.773C7.51992 17.0659 7.9948 17.0659 8.28769 16.773C8.58058 16.4801 8.58058 16.0052 8.28769 15.7123C7.3368 14.7614 6.75 13.45 6.75 12Z" fill="currentColor"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.25 12C9.25 10.4812 10.4812 9.25 12 9.25C13.5188 9.25 14.75 10.4812 14.75 12C14.75 13.5188 13.5188 14.75 12 14.75C10.4812 14.75 9.25 13.5188 9.25 12ZM12 10.75C11.3096 10.75 10.75 11.3096 10.75 12C10.75 12.6904 11.3096 13.25 12 13.25C12.6904 13.25 13.25 12.6904 13.25 12C13.25 11.3096 12.6904 10.75 12 10.75Z" fill="currentColor"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.393 15.7434C13.0153 15.4757 12.6097 15.2765 12.1173 15.2528C12.0392 15.2491 11.9608 15.2491 11.8827 15.2528C11.3903 15.2765 10.9847 15.4757 10.607 15.7434C10.255 15.993 9.86615 16.3479 9.41455 16.7602L9.33587 16.832C8.33098 17.7493 7.51836 18.4911 7.00062 19.1089C6.50359 19.702 6.04684 20.4464 6.34164 21.2757C6.38098 21.3864 6.42962 21.4935 6.48687 21.5959C6.89759 22.331 7.73235 22.5508 8.53456 22.6483C9.3717 22.75 10.5153 22.75 11.9436 22.75H12.0563C13.4847 22.75 14.6283 22.75 15.4654 22.6483C16.2676 22.5508 17.1024 22.331 17.5131 21.5959C17.5704 21.4935 17.619 21.3864 17.6584 21.2757C17.9532 20.4464 17.4964 19.702 16.9994 19.1089C16.4816 18.4911 15.669 17.7493 14.6641 16.832L14.5854 16.7602C14.1338 16.3479 13.745 15.993 13.393 15.7434ZM11.4744 16.9671C11.7245 16.7899 11.8549 16.7559 11.9547 16.7511C11.9849 16.7496 12.0151 16.7496 12.0453 16.7511C12.1451 16.7559 12.2755 16.7899 12.5256 16.9671C12.7928 17.1566 13.1132 17.4473 13.607 17.898C14.6685 18.867 15.4046 19.5412 15.8497 20.0724C16.0699 20.3352 16.1778 20.5162 16.224 20.6375C16.2605 20.7334 16.249 20.7631 16.2455 20.772L16.245 20.7733C16.2341 20.804 16.2204 20.8344 16.2037 20.8643C16.1842 20.8991 16.0659 21.0643 15.2845 21.1592C14.549 21.2486 13.4975 21.25 12 21.25C10.5025 21.25 9.45103 21.2486 8.71554 21.1592C7.93413 21.0643 7.81578 20.8991 7.79635 20.8643C7.77964 20.8344 7.7659 20.804 7.75501 20.7733L7.75452 20.772C7.75105 20.7631 7.7395 20.7334 7.77599 20.6375C7.82219 20.5162 7.93006 20.3352 8.15029 20.0724C8.59539 19.5412 9.33155 18.867 10.393 17.898C10.8868 17.4473 11.2072 17.1566 11.4744 16.9671Z" fill="currentColor"/>
                  </svg>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex flex-col gap-1">
                  <!--  -->
                  <span class="text-xl font-medium">{{ $t('company') }}</span>
                  <!--  -->
                  <span class="text-base font-normal text-gray-600">{{ order.seller.company || order.seller.fullName }}</span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="bg-white w-full lg:w-1/4 flex items-center gap-4 rounded-lg p-4 border border-solid border-orange-400">
                <!--  -->
                <div class="flex items-center justify-center">
                  <svg class="w-10 h-10 text-orange-500" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" id="magicoon-Regular">
                    <path id="store-Regular-2" data-name="store-Regular" class="cls-1" d="M21.75,9a.742.742,0,0,0-.039-.238L20.623,5.5A4.743,4.743,0,0,0,16.117,2.25H7.883A4.743,4.743,0,0,0,3.377,5.5L2.289,8.763A.742.742,0,0,0,2.25,9a3.734,3.734,0,0,0,1,2.53V18A3.754,3.754,0,0,0,7,21.75h3.777V18a1.25,1.25,0,0,1,2.5,0v3.75H17A3.754,3.754,0,0,0,20.75,18V11.531A3.734,3.734,0,0,0,21.75,9ZM4.8,5.972A3.246,3.246,0,0,1,7.883,3.75h8.234A3.246,3.246,0,0,1,19.2,5.972l1.047,3.141A2.222,2.222,0,0,1,18.01,11.25a2.48,2.48,0,0,1-2.3-1.5A.75.75,0,0,0,15,9.25h0a.748.748,0,0,0-.706.507,2.5,2.5,0,0,1-4.582,0A.748.748,0,0,0,9,9.25H9a.75.75,0,0,0-.708.5,2.48,2.48,0,0,1-2.3,1.5A2.222,2.222,0,0,1,3.753,9.113ZM17,20.25H14.777V18a2.75,2.75,0,0,0-5.5,0v2.25H7A2.252,2.252,0,0,1,4.75,18V12.521a3.676,3.676,0,0,0,1.24.229A4.13,4.13,0,0,0,9,11.423a4.064,4.064,0,0,0,6.008,0A4.13,4.13,0,0,0,18.01,12.75a3.676,3.676,0,0,0,1.24-.229V18A2.252,2.252,0,0,1,17,20.25Z" fill="currentColor"/>
                  </svg>
                </div>
                <!--  -->

                <!--  -->
                <div class="flex flex-col gap-1">
                  <!--  -->
                  <span class="text-xl font-medium">{{ $t('store') }}</span>
                  <!--  -->

                  <!--  -->
                  <a class="no-underline relative text-gray-600" :href="order.source || null" target="_blank">
                    <!--  -->
                    <svg class="fill-current inline-block pb-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" v-if="order.source && $f.validURL(order.source)">
                      <!--  -->
                      <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z" />
                      <!--  -->
                    </svg>
                    <!--  -->

                    <!--  -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none" v-else>
                      <!--  -->
                      <path id="Vector" d="M8 12H12M12 12L8 8M12 12L20 20M15 8H17C19.2091 8 21 9.79086 21 12C21 13.1947 20.4759 14.2671 19.6455 15M9 16H7C4.79086 16 3 14.2091 3 12C3 9.79086 4.79086 8 7 8H8M8 8L4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <!--  -->
                    </svg>
                    <!--  -->
                  </a>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="order.remind" class="flex btn-marketing mt-8 p-3 text-orange-800 border-t-4 border-orange-300 bg-orange-100 shadow" role="alert">
            <!--  -->
            <svg class="flex-shrink-0 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <!--  -->
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
              <!--  -->
            </svg>
            <!--  -->
            <div class="ml-3 text-sm font-medium">
              <!--  -->
              Cette commande est déjà reportée pour la date
              <!--  -->
              {{ $moment(order.remind).format('yyyy-MM-DD HH:mm') }}.
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="order.shippings && order.shippings.status" class="flex btn-marketing mt-8 text-orange-600 border-t-4 border-orange-300 bg-orange-100 py-2 px-4" role="alert">
            <!--  -->
            <svg class="flex-shrink-0 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <!--  -->
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
              <!--  -->
            </svg>
            <!--  -->

            <!--  -->
            <div class="ml-3">
              <!--  -->
              <span class="text-base font-normal"> 
                <!--  -->
                <span>This order is already in the shipping orders with status: </span>
                <!--  -->
                <span class="capitalize font-medium">{{ order.shippings.status }}</span>
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="card-1 w-full mt-8 rounded-lg">
            <!--  -->
            <div class="bg-white flex items-center justify-between px-4 py-3 rounded-lg">
              <!--  -->
              <div class="flex items-center gap-2">
                <!--  -->
                <svg class="w-7 h-7 flex items-center justify-center text-gray-700" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 6.25C7.48122 6.25 6.25 7.48122 6.25 9C6.25 10.5188 7.48122 11.75 9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.48122 10.5188 6.25 9 6.25ZM7.75 9C7.75 8.30965 8.30965 7.75 9 7.75C9.69036 7.75 10.25 8.30965 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30965 10.25 7.75 9.69036 7.75 9Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 12.25C7.80424 12.25 6.68461 12.4907 5.83616 12.915C5.03258 13.3168 4.25 14.0106 4.25 15L4.24987 15.0625C4.24834 15.5728 4.24576 16.4322 5.06023 17.0218C5.43818 17.2953 5.9369 17.4698 6.55469 17.581C7.1782 17.6932 7.97721 17.75 9 17.75C10.0228 17.75 10.8218 17.6932 11.4453 17.581C12.0631 17.4698 12.5618 17.2953 12.9398 17.0218C13.7542 16.4322 13.7517 15.5728 13.7501 15.0625L13.75 15C13.75 14.0106 12.9674 13.3168 12.1638 12.915C11.3154 12.4907 10.1958 12.25 9 12.25ZM5.75 15C5.75 14.8848 5.86285 14.5787 6.50698 14.2566C7.10625 13.957 7.98662 13.75 9 13.75C10.0134 13.75 10.8937 13.957 11.493 14.2566C12.1371 14.5787 12.25 14.8848 12.25 15C12.25 15.6045 12.2115 15.6972 12.0602 15.8067C11.9382 15.895 11.6869 16.0134 11.1797 16.1047C10.6782 16.1949 9.97721 16.25 9 16.25C8.02279 16.25 7.3218 16.1949 6.82031 16.1047C6.31311 16.0134 6.06182 15.895 5.93977 15.8067C5.78849 15.6972 5.75 15.6045 5.75 15Z" fill="currentColor"/>
                  <path d="M19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19Z" fill="currentColor"/>
                  <path d="M19.75 9C19.75 9.41422 19.4142 9.75 19 9.75H14C13.5858 9.75 13.25 9.41422 13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9Z" fill="currentColor"/>
                  <path d="M19 15.75C19.4142 15.75 19.75 15.4142 19.75 15C19.75 14.5858 19.4142 14.25 19 14.25H16C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H19Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0565 20.75H9.94359C8.10585 20.75 6.65018 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10583 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02503 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02503 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02503 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02503 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976Z" fill="currentColor"/>
                </svg>
                <!--  -->
                <span class="text-base font-medium">{{ $t('customer_information') }}</span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="flex items-center justify-center" @click="openWhatsApp">
                <!--  -->
                <svg class="w-8 h-8 flex items-center justify-center" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 48 48" version="1.1">
                  <!--  -->
                  <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <!--  -->
                    <g id="Color-" transform="translate(-700.000000, -360.000000)" fill="#67C15E">
                      <!--  -->
                      <path d="M723.993033,360 C710.762252,360 700,370.765287 700,383.999801 C700,389.248451 701.692661,394.116025 704.570026,398.066947 L701.579605,406.983798 L710.804449,404.035539 C714.598605,406.546975 719.126434,408 724.006967,408 C737.237748,408 748,397.234315 748,384.000199 C748,370.765685 737.237748,360.000398 724.006967,360.000398 L723.993033,360.000398 L723.993033,360 Z M717.29285,372.190836 C716.827488,371.07628 716.474784,371.034071 715.769774,371.005401 C715.529728,370.991464 715.262214,370.977527 714.96564,370.977527 C714.04845,370.977527 713.089462,371.245514 712.511043,371.838033 C711.806033,372.557577 710.056843,374.23638 710.056843,377.679202 C710.056843,381.122023 712.567571,384.451756 712.905944,384.917648 C713.258648,385.382743 717.800808,392.55031 724.853297,395.471492 C730.368379,397.757149 732.00491,397.545307 733.260074,397.27732 C735.093658,396.882308 737.393002,395.527239 737.971421,393.891043 C738.54984,392.25405 738.54984,390.857171 738.380255,390.560912 C738.211068,390.264652 737.745308,390.095816 737.040298,389.742615 C736.335288,389.389811 732.90737,387.696673 732.25849,387.470894 C731.623543,387.231179 731.017259,387.315995 730.537963,387.99333 C729.860819,388.938653 729.198006,389.89831 728.661785,390.476494 C728.238619,390.928051 727.547144,390.984595 726.969123,390.744481 C726.193254,390.420348 724.021298,389.657798 721.340985,387.273388 C719.267356,385.42535 717.856938,383.125756 717.448104,382.434484 C717.038871,381.729275 717.405907,381.319529 717.729948,380.938852 C718.082653,380.501232 718.421026,380.191036 718.77373,379.781688 C719.126434,379.372738 719.323884,379.160897 719.549599,378.681068 C719.789645,378.215575 719.62006,377.735746 719.450874,377.382942 C719.281687,377.030139 717.871269,373.587317 717.29285,372.190836 Z" id="Whatsapp"></path>
                      <!--  -->
                    </g>
                    <!--  -->
                  </g>
                  <!--  -->
                </svg>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="relative w-full flex items-center justify-center p-8">
                <!--  -->
                <div class="w-full flex flex-col gap-4">
                  <!--  -->
                  <div class="icon bg-green-600 text-white w-6 h-6 absolute flex items-center justify-center p-5" style="left: -40px">
                    <!--  -->
                    <i class="fal fa-phone-volume fa-fw text-2xl">
                      <!--  -->
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="fill-current h-6 w-6">
                        <!--  -->
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z" />
                        <!--  -->
                      </svg>
                      <!--  -->
                    </i>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <h5 class="text-2xl text-gray-900 font-semibold pb-6">
                    <!--  -->
                    {{ $t('call_customer') }}
                    <!--  -->
                  </h5>
                  <!--  -->

                  <!--  -->
                  <div class="grid lg:grid-cols-2 gap-6">
                    <!--  -->
                    <div class="border border-white hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1" :class="style ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-orange-500 hover:border-orange-600' : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'">
                      <!--  -->
                      <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
                        <!--  -->
                        <p>
                          <!--  -->
                          <label class="capitalize text-gray-800 px-1 text-xs font-medium">
                            {{ $t('full_name') }} *
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <p>
                        <!--  -->
                        <input id="name" autocomplete="false" tabindex="0" type="text" disabled :placeholder="$t('full_name')" v-model="order.customer.fullName" :class="style ? 'bg-white rounded-sm py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-orange-500 hover:border-orange-600' : 'bg-white rounded-sm py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none' " />
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="border border-white hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1" :class="style ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-orange-500 hover:border-orange-600' : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'">
                      <!--  -->
                      <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
                        <!--  -->
                        <p>
                          <!--  -->
                          <label for="phone" class="capitalize text-gray-800 px-1 text-xs font-medium">
                            {{ $t('phone') }} *
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </div>
                      <!--  -->
                      <p>
                        <!--  -->
                        <input autocomplete="false" tabindex="0" type="tel" disabled v-model="order.customer.phone" :class="style ? 'bg-white rounded-sm py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-orange-500 hover:border-orange-600' : 'bg-white rounded-sm  py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'" />
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="grid lg:grid-cols-1 gap-6 mt-2">
                    <!--  -->
                    <div class="border border-white hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1"  :class="style ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-orange-500 hover:border-orange-600' : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'">
                      <!--  -->
                      <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
                        <!--  -->
                        <p>
                          <!--  -->
                          <label for="address" class="capitalize text-gray-800 px-1 text-xs font-medium">
                            {{ $t('address') }} *
                          </label>
                          <!--  -->
                        </p>
                        <!--  -->
                      </div>
                      <!--  -->
                      <p>
                        <!--  -->
                        <span class="bg-white rounded-sm border hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative p-1" :class="style ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-orange-500 hover:border-orange-600' : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none' ">
                          {{ order.customer.address || order.customer.city}}
                        </span>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="card-1 w-full mt-8 rounded-lg">
            <!--  -->
            <div class="bg-white flex items-center justify-between px-4 py-3 rounded-lg">
              <!--  -->
              <div class="flex items-center gap-2">
                <!--  -->
                <svg class="w-7 h-7 flex items-center justify-center text-gray-700" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                  <!--  -->
                  <path d="M23 6.066v12.065l-11.001 5.869-11-5.869v-12.131l11-6 11.001 6.066zm-21.001 11.465l9.5 5.069v-10.57l-9.5-4.946v10.447zm20.001-10.388l-9.501 4.889v10.568l9.501-5.069v-10.388zm-5.52 1.716l-9.534-4.964-4.349 2.373 9.404 4.896 4.479-2.305zm-8.476-5.541l9.565 4.98 3.832-1.972-9.405-5.185-3.992 2.177z" fill="currentColor"/>
                  <!--  -->
                </svg>
                <!--  -->
                <span class="text-base font-medium">{{ $t('order_products') }}</span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <button @click="OpenPopUp" class="flex text-white rounded-md text-center bg-orange-400 py-2 px-4 items-center focus:outline-none">
                {{ $t('select_product') }}
              </button>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="w-full flex flex-col items-center gap-4 justify-center p-8">
              <!--  -->
              <div class="w-full antialiased font-san rounded-lg overflow-hidden bg-white">
                <!--  -->
                <div class="overflow-x-auto">
                  <!--  -->
                  <div class="inline-block min-w-full rounded-lg overflow-hidden">
                    <!--  -->
                    <table v-if="order.details && this.calculate.length > 0" class="min-w-full leading-normal">
                      <!--  -->
                      <thead>
                        <!--  -->
                        <tr class="bg-gray-300">
                          <!--  -->
                          <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                            {{ $t('name') }}
                          </th>
                          <!--  -->
                          
                          <!--  -->
                          <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                            {{ $t('unit_price') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                            {{ $t('quantity') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                            {{ $t('total') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider">
                            {{ $t('actions') }}
                          </th>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </thead>
                      <!--  -->

                      <!--  -->
                      <tbody v-for="(item, index) in order.details" :key="index">
                        <!--  -->
                        <tr>
                          <!--  -->
                          <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                            <!--  -->
                            <div class="flex items-center">
                              <!--  -->
                              <img class="h-10 w-10 rounded-md" alt="default image" :src="item.product.picture ? item.product.picture : 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"/>
                              <!--  -->
                              
                              <!--  -->
                              <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900 font-bold">
                                  {{ item.product.name }}
                                  <!--  -->
                                  <p v-if=" (item.product.variantes && item.product.variantes.length > 0 && item.product.source) || (item.variante && item.variante.id)">
                                    <!--  -->
                                    <small>Varinate: {{ item.variante ? item.variante.name : item.product.source.name }}</small>
                                    <!--  -->
                                  </p>
                                  <!--  -->
                                  <div v-if="checkUpselExist(item.product)" @click="openModal('upsell', item.product.name,checkUpselExist(item.product))" class="mt-2 d-inline-flex border border-gray-600 border-dashed pl-1 animation-pulse cursor-pointer">
                                      <b style="font-size: 15px;" class="text-red-700">Up-Sells</b> <img class="h-8 w-8 inline float-right rounded-full object-cover mx-1" src="https://img.icons8.com/stickers/100/sale-price-tag.png" alt="avatar">
                                  </div>
                                  <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                            <!--  -->
                            <div>
                              <!--  -->
                              <input @input="calculateQtePrice(index, 'total')" autocomplete="off" tabindex="0" min="0" type="number" v-model.number="item.unitPrice" class="border border-orange-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-md overflow-hidden" />
                              <!--  -->
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                            <!--  -->
                            <div class="flex space-x-6">
                              <!--  -->
                              <button :class="$colors.textPrimary" class="bg-primary-600 rounded-md w-6 h-6 flex items-center focus:outline-none" @click="addQuantity(index)">
                                <!--  -->
                                <span class="font-bold text-2xl text-white">
                                  <!--  -->
                                  <i class="material-icons mt-2">add</i>
                                  <!--  -->
                                </span>
                                <!--  -->
                              </button>
                              <!--  -->

                              <!--  -->
                              <span :class="$colors.textPrimary" class="text-gray-700 text-sm h-6 flex items-center focus:outline-none">
                                <!--  -->
                                <input class="focus:outline-none w-12 text-center" type="text" v-model="item.quantity" @input="calculateQtePrice(index, calculate[index].type)" />
                                <!--  -->
                              </span>
                              <!--  -->

                              <!--  -->
                              <button :class="$colors.textPrimary" @click="removeQuantity(index)" class="bg-primary-600 rounded-md w-6 h-6 text-white flex items-center focus:outline-none">
                                <!--  -->
                                <span class="font-bold text-2xl text-white mt-1">
                                  <!--  -->
                                  <i class="material-icons">remove</i>
                                  <!--  -->
                                </span>
                                <!--  -->
                              </button>
                              <!--  -->
                            </div>
                            <!--  -->
                            <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                            <!--  -->
                            <div class="flex items-center gap-2">
                              <!--  -->
                              <input @input="calculateQtePrice(index, 'price')" autocomplete="off" min="0" type="number" v-model.number="calculate[index].price" class="border border-orange-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-md overflow-hidden" />
                              <!--  -->
                              <sup class="text-black" v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                              <!--  -->
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td class="py-4 whitespace-no-wrap border-b border-gray-200">
                            <!--  -->
                            <div class="flex justify-center items-center gap-2">
                              <!--  -->
                              <button @click="removeProduct(item, index)" :class="$colors.actionTable" class="rounded-full flex focus:outline-none">
                                <!--  -->
                                <i class="flex items-center justify-center material-icons mx-1">delete</i>
                                <!--  -->
                              </button>
                              <!--  -->

                              <!--  -->
                              <div class="text-center">
                                <!--  -->
                                <a class="no-underline relative text-orange-600" :href="item.product.verificationLink || null" target="_blank">
                                  <!--  -->
                                  <svg class="fill-current inline-block pb-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" v-if="item.product.verificationLink && $f.validURL(item.product.verificationLink)">
                                    <!--  -->
                                    <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z" />
                                    <!--  -->
                                  </svg>
                                  <!--  -->

                                  <!--  -->
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none" v-else>
                                    <!--  -->
                                    <path id="Vector" d="M8 12H12M12 12L8 8M12 12L20 20M15 8H17C19.2091 8 21 9.79086 21 12C21 13.1947 20.4759 14.2671 19.6455 15M9 16H7C4.79086 16 3 14.2091 3 12C3 9.79086 4.79086 8 7 8H8M8 8L4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <!--  -->
                                  </svg>
                                  <!--  -->
                                </a>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </tbody>
                      <!--  -->
                    </table>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="flex items-center justify-center gap-2 pb-2 pt-1">
                  <!--  -->
                  <span class="font-bold text-orange-700">
                    <!--  -->
                    {{ $t('total_price') }} :
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="rounded-full bg-orange-100 text-orange-500 py-1 px-2">
                    <!--  -->
                    <span class="justify-center text-center w-auto rounded-full">
                      <!--  -->
                      {{ (TotalPrice()).toFixed(2) }}
                      <!--  -->
                      <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                      <!--  -->
                    </span>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="loidingconfirm relative flex gap-2 text-white rounded-md text-center bg-orange-600 py-2 px-6 items-center cursor-pointer focus:outline-none" :class="loadingUpdateOrder ? 'noselect' : ''" @click="UpdateOrder()">
                <!--  -->
                <loading :active.sync="loadingUpdateOrder" :is-full-page="fullPage"></loading>
                <!--  -->
                <i class="material-icons">save</i>
                <!--  -->
                <span>{{ $t('save') }}</span> 
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <div class="flex items-center justify-center mt-16">
            <!--  -->
            <div v-if="order.shippings && order.shippings.status" class="flex justify-center w-full space-x-2">
              <!--  -->
              <button v-if="order.shippings.status === 'refused'" @click="openModal('myModalReprogrammed')" class="w-1/6 p-3 rounded bg-purple-600 hover:bg-purple-500 text-white font-semibold focus:outline-none">
                {{ $t("reprogram") }}
              </button>
              <!--  -->

              <!--  -->
              <button v-else @click="openModal('myModalInterested')" class="w-1/6 p-3 rounded bg-indigo-600 hover:bg-indigo-500 text-white font-semibold focus:outline-none">
                {{ $t("interested") }}
              </button>
              <!--  -->

              <!--  -->
              <button @click="openModal('myModalUnreachable')" class="w-1/6 p-3 rounded bg-yellow-500 hover:bg-yellow-600 text-white font-semibold focus:outline-none">
                {{ $t("unreachable") }}
              </button>
              <!--  -->

              <!--  -->
              <button @click="openModal('myModalCancelled')" class="w-1/6 p-3 rounded bg-red-600 hover:bg-red-500 text-white font-semibold focus:outline-none">
                {{ $t("cancelled") }}
              </button>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-else class="flex justify-center w-full space-x-2">
              <!--  -->
              <button @click="openModal('myModalConfirm')" class="w-1/6 p-3 rounded bg-green-600 hover:bg-green-500 text-white font-semibold focus:outline-none">
                <!--  -->
                {{ $t('confirm') }}
                <!--  -->
              </button>
              <!--  -->
              <template v-if=" currentUser && (currentUser.type == 'TeleConsultant' || currentUser.type == 'ToRemind')">
                <!--  -->
                <button @click="$vm2.open('myModalUncached')" class="w-1/6 p-3 rounded bg-orange-600 hover:bg-orange-500 text-white font-semibold focus:outline-none">
                  <!--  -->
                  {{ $t('unreached') }}
                  <!--  -->
                </button>
                <!--  -->
                <button @click="$vm2.open('myModalRemanded')" class="w-1/6 p-3 rounded bg-purple-600 hover:bg-purple-500 text-white font-semibold focus:outline-none">
                  <!--  -->
                  {{ $t('to_remind') }}
                  <!--  -->
                </button>
                <!--  -->
              </template>
              <!--  -->
              <button @click="$vm2.open('myModalCancel')" class="w-1/6 p-2 rounded bg-red-600 hover:bg-red-500 text-white font-semibold focus:outline-none">
                <!--  -->
                {{ $t('cancelled') }}
                <!--  -->
              </button>
              <!--  -->
              <button @click="$vm2.open('myModalSkipped')" class="w-1/6 p-2 rounded bg-orange-600 hover:bg-orange-500 text-white font-semibold focus:outline-none">
                <!--  -->
                {{ $t('skip') }}
                <!--  -->
              </button>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
          
          <!--  -->
          <vue-modal-2 name="myModalConfirm" :headerOptions="{ title: $t('confirmation_order') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalConfirm')">
            <!--  -->
            <div class="p-4 pt-0 relative">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div>
                <!--  -->
                <div class="flex flex-col md:flex-row">
                  <!--  -->
                  <div class="w-full mx-2 flex-1 svelte-1l8159u">
                    <!--  -->
                    <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">
                      <!--  -->
                      {{ $t('shipping_date') }}
                      <!--  -->
                    </label>
                    <!--  -->
                    <datetime-v2 :min-datetime="minDate" v-model="shipping.date" :placeholder="$t('shipping_date')" type="datetime" input-class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-2 px-3 text-grey-darker"></datetime-v2>
                    <!--  -->
                    <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">
                      <!--  -->
                      {{ $t('city') }}
                      <!--  -->
                    </label>
                    <!--  -->
                    <div class="shadow bg-white my-2 p-1 flex border-2 border-gray-500 rounded svelte-1l8159u">
                      <!--  -->
                      <v-select v-model="order.customer.city" :options="cities"></v-select>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                  <div class="w-full mx-2 flex-1 svelte-1l8159u">
                    <!--  -->
                    <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">
                      <!--  -->
                      {{ $t('phone_2') }}</label>
                      <!--  -->
                      <input type="tel" :placeholder="$t('telephone')" v-model="order.customer.shippingPhone" class="shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                      <!--  -->
                      <label for="shipp-add" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">
                      <!--  -->
                      {{ $t('shipping_address') }}
                      <!--  -->
                    </label>
                    <!--  -->
                    <textarea id="shipp-add" v-model="order.customer.shippingAddress" cols="10" rows="5" :placeholder="$t('shipping_address_hint')" class="my-2 p-1 shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
                <div class="w-full mx-2 flex-1 svelte-1l8159u">
                  <!--  -->
                  <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">{{ $t('add_comment') }}</label>
                  <!--  -->
                  <div class="velte-1l8159u" style="margin-right: 15px">
                    <!--  -->
                    <textarea id="commentConfirmation" cols="10" rows="3" :placeholder="$t('comment_hint')"  v-model="order.comment"  class="my-2 p-1 shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
              <div class="flex p-2 mt-4">
                <!--  -->
                <div class="flex-auto flex flex-row-reverse">
                  <!--  -->
                  <button @click="ConfirmOrderStatus(order)" class="w-1/6 p-3 rounded bg-green-600 hover:bg-green-500 text-white font-semibold focus:outline-none">
                    <!--  -->
                    {{ $t('confirm') }}
                    <!--  -->
                  </button>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalCancel" :headerOptions="{ title: $t('cancelation_order') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalCancel')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <label class="block text-grey-darker text-sm font-bold mb-2" for="content">{{
                    $t('reason_for_cancellation') }}
                    <!--  -->
                    <span :class="$colors.required">*</span></label>
                    <!--  -->
                    <p>
                    <!--  -->
                    <textarea id="content" cols="10" rows="3" :placeholder="$t('content_hint')" v-model="motifAnnulation" class="focus:outline-none shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-grey-darker mb-3"></textarea>
                    <!--  -->
                  </p>
                  <!--  -->
                  <div class="flex space-x-2">
                    <!--  -->
                    <button @click="cancelOrder(order)" class="w-full mt-2 bg-orange-600 focus:outline-none hover:bg-orange-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t('cancel_order') }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalRemanded" :headerOptions="{ title: $t('remonded_order') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalRemanded')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 pt-6 pb-8 flex flex-col">
                <!--  -->
                <div class="mb-4">
                  <!--  -->
                  <label class="block text-grey-darker text-sm font-bold mb-2" for="dateremind">
                    <!--  -->
                    {{ $t('remind_date') }} :
                    <!--  -->
                  </label>
                  <!--  -->
                  <datetime-v2 :min-datetime="minDate" v-model="remindDate" :placeholder="$t('remind_date')" type="datetime" input-class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker"></datetime-v2>
                  <!--  -->
                </div>
                <!--  -->
                <div class="mb-6">
                  <!--  -->
                  <label class="block text-grey-darker text-sm font-bold mb-2" for="content">{{ $t('content') }}</label>
                  <!--  -->
                  <textarea id="content" cols="10" rows="3" :placeholder="$t('content_hint')" v-model="contentRemend" class="focus:outline-none shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3"></textarea>
                  <!--  -->
                </div>
                <!--  -->
                <div class="flex items-center justify-between">
                  <!--  -->
                  <button @click="RemindOrder(order)" class="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded" type="button">
                    <!--  -->
                    {{ $t('confirm') }}
                    <!--  -->
                  </button>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalUncached" :headerOptions="{ title: $t('unrached_order') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalUncached')">
            <!--  -->
            <div class="flex flex-col w-full h-auto">
              <!--  -->
              <div class="bg-white rounded px-8 pt-6 pb-8 flex flex-col">
                <!--  -->
                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <!--  -->
                <div class="my-6">
                  <!--  -->
                  <div class="border seller-select h-10 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label for="seller" class="bg-white text-gray-700 px-1">
                          <!--  -->
                          {{ $t('reason_unreached') }}
                          <!--  -->
                          <span :class="$colors.required">*</span>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->
                    <p>
                      <!--  -->
                      <v-select v-model="reasonUnreached" :options="commentsUnreached"></v-select>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
                <div class="flex items-center justify-between">
                  <!--  -->
                  <button :disabled="loading" @click="UnreachedOrder(order)" class="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded" type="button">
                    <!--  -->
                    {{ $t('confirm_unreached') }}
                    <!--  -->
                  </button>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalSkipped" :headerOptions="{ title: $t('skipped_order') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalSkipped')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <label class="block text-grey-darker text-sm font-bold mb-2" for="content">{{
                    $t('reason_for_skipped') }}
                    <!--  -->
                    <span :class="$colors.required">*</span></label>
                    <!--  -->
                    <p>
                    <!--  -->
                    <textarea id="content" cols="10" rows="3" :placeholder="$t('content_hint')" v-model="contentSkipped" class="focus:outline-none shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-grey-darker mb-3"></textarea>
                    <!--  -->
                  </p>
                  <!--  -->
                  <div class="flex space-x-2">
                    <!--  -->
                    <button @click="skipOrder(order, 'skip')" class="w-full mt-2 bg-orange-600 focus:outline-none hover:bg-orange-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t('order_skip') }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->
          
          <!--  -->
          <vue-modal-2 name="myModalDouble" :headerOptions="{ title: 'Double orders' }" :noFooter="true" modalSize="xl" @on-close="closeModal('myModalDouble')">
            <!--  -->
            <div class="flex flex-col w-full h-auto p-5 pt-0 bottom_bitt">
              <!--  -->
              <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg" style="margin-bottom: 62px">
                <!--  -->
                <table class="min-w-full">
                  <!--  -->
                  <thead>
                    <!--  -->
                    <tr>
                      <!--  -->
                      <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4 text-green-600 tracking-wider">
                        <!--  -->
                        ID order
                        <!--  -->
                      </th>
                      <!--  -->
                      <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-green-600 tracking-wider">
                        <!--  -->
                        {{ $t('customer') }}
                        <!--  -->
                      </th>
                      <!--  -->
                      <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-green-600 tracking-wider">
                        <!--  -->
                        {{ $t('products') }}
                        <!--  -->
                      </th>
                      <!--  -->
                      <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-green-600 tracking-wider">
                        <!--  -->
                        {{ $t('total_price') }}
                        <!--  -->
                      </th>
                      <!--  -->
                      <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4 text-green-600 tracking-wider">
                        <!--  -->
                        {{ $t('status') }}
                        <!--  -->
                      </th>
                      <!--  -->
                      <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-right text-sm leading-4 text-green-600 tracking-wider">
                        <!--  -->
                        {{ $t('action') }}
                        <!--  -->
                      </th>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </thead>
                  <!--  -->
                  <tbody class="bg-white">
                    <!--  -->
                    <tr v-for="(order, ind) in dataDouble" :key="ind">
                      <!--  -->
                      <td class="border-t-2 border-gray-300 px-3 py-1">
                        <!--  -->
                        <div class="flex items-center">
                          <!--  -->
                          <div>
                            <!--  -->
                            <div class="text-sm leading-5 text-gray-800">
                              <!--  -->
                              {{ order.id }}
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                      <td class="border-t-2 border-gray-300 px-3 py-1">
                        <!--  -->
                        <div class="text-sm leading-5 siz12 text-orange-900">
                          <!--  -->
                          <div class="flex-grow-1">
                            <!--  -->
                            <h5 class="fs-14 mb-1">
                              <!--  -->
                              {{ order.customer.fullName }}
                              <!--  -->
                            </h5>
                            <!--  -->
                            <p class="badge badge-soft-success text-uppercase">
                              <!--  -->
                              {{ order.customer.phone }}
                              <!--  -->
                            </p>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                      <td class="border-t-2 border-gray-300 px-3 py-1">
                        <!--  -->
                        <div class="text-sm leading-5 text-orange-900">
                          <!--  -->
                          {{ sumProduct(order.details) }}
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                      <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                        <!--  -->
                        <div class="text-sm leading-5 text-orange-900">
                          <!--  -->
                          {{ order.totalPrice }}
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                      <td class="border-t-2 border-gray-300 px-3 py-1">
                        <!--  -->
                        <div class="text-sm leading-5 text-orange-900" v-bind:style="{ color: order.status.name ? order.status.color : '', borderColor: order.status.name ? order.status.color : ''}">
                          <!--  -->
                          {{ order.status.name }}
                          <!--  -->
                        </div>
                        <!--  -->
                        <td class="border-t-2 border-gray-300 px-3 py-1 text-right">
                          <!--  -->
                        </td>
                        <!--  -->
                        <router-link target="_blank" :to="{ path: `/orders/detail/${order._id}` }" class="text-sm leading-5 px-2 rounded-full text-xs text-orange-900 cursor-pointer font-medium">
                          <!--  -->
                          <i class="material-icons mx-2"> remove_red_eye</i></router-link>
                          <!--  -->
                        </td>
                        <!--  -->
                      </tr>
                      <!--  -->
                    </tbody>
                    <!--  -->
                  </table>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
              <div class="modal-footer px-5 border0-t text-right">
              <!--  -->
              <button @click="closeModal('myModalDouble')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
                <!--  -->
                Cancel
                <!--  -->
              </button>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->
          
          <!--  -->
          <vue-modal-2 name="warehouseParent" :headerOptions="{ title: 'Choisir la ville de stockage' }" :noFooter="true" modalSize="md">
            <!--  -->
            <div class="flex flex-col w-full h-auto">
              <!--  -->
              <div class="bg-white rounded px-2 pb-2 flex flex-col">
                <!--  -->
                <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <!--  -->
                <p class="font-bold text-center">
                  <!--  -->
                  S'il vous plait Choisir la ville de stockage de produit
                  <!--  -->
                </p>
                <!--  -->
                <div class="shadow bg-white my-2 p-1 border-2 border-gray-500 rounded svelte-1l8159u">
                  <!--  -->
                  <v-select v-model="order.zone" :options="checkWarehouseParent" label="name"></v-select>
                  <!--  -->
                </div>
                <!--  -->
                <div class="flex p-2 mt-4">
                  <!--  -->
                  <div class="flex-auto flex flex-row-reverse">
                    <!--  -->
                    <button :disabled="loading" @click="ConfirmOrderStatus(order, 'warehouseParent')" class="w-1/3 p-3 btn-action rounded bg-orange-600 hover:bg-orange-500 text-white font-semibold focus:outline-none">
                      <!--  -->
                      {{ $t('confirm') }}
                      <!--  -->
                    </button>
                    <!--  -->
                    <button :disabled="loading" @click="closeModal('warehouseParent')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">
                      <!--  -->
                      Annuler
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalReprogrammed" :headerOptions="{ title: $t('Reprogrammer') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalReprogrammed')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  
                  <!--  -->
                  <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{ $t("shipping_date") }}</label>
                  <!--  -->

                  <!--  -->
                  <datetime-v2 :min-datetime="minDate" v-model="newShippingDate" :placeholder="$t('shipping_date')" type="datetime" input-class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-2 px-3 text-grey-darker"></datetime-v2>
                  <!--  -->
                  
                  <!--  -->
                  <div class="flex space-x-2 mt-3 ">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'reprogram')" :disabled="loading" class="w-full mt-2 bg-orange-600 focus:outline-none rounded-md hover:bg-orange-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalInterested" :headerOptions="{ title: $t('interested') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalInterested')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase"> {{ $t("shipping_date") }} </label>
                  <!--  -->

                  <!--  -->
                  <datetime-v2 :min-datetime="minDate" v-model="newShippingDate" :placeholder="$t('shipping_date')" type="datetime" input-class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-2 px-3 text-grey-darker"></datetime-v2>
                  <!--  -->

                  <!--  -->
                  <div class="flex space-x-2 mt-3 ">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'interested')" :disabled="loading" class="w-full mt-2 bg-orange-600 focus:outline-none rounded-md hover:bg-orange-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalUnreachable" :headerOptions="{ title: $t('unreachable') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalUnreachable')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <div class="flex flex-col gap-2 my-3">
                    <!--  -->
                    <label for="shipp-date" class="font-bold h-6 text-gray-800 text-xs leading-8 uppercase">{{ $t('reason_unreached') }}</label>
                    <!--  -->

                    <!--  -->
                    <v-select class="focus:outline-none shadow appearance-none border-2 border-gray-500 rounded w-full py-1 px-3 text-grey-darker" v-model="reasonUnreached" :options="commentsUnreached"></v-select>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="flex space-x-2 mt-3 ">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'unreachable')" :disabled="loading" class="w-full mt-2 bg-orange-600 focus:outline-none rounded-md hover:bg-orange-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModalCancelled" :headerOptions="{ title: $t('cancelled') }" :noFooter="true" modalSize="lg" @on-close="closeModal('myModalCancelled')">
            <!--  -->
            <div class="relative flex flex-col w-full h-auto">
              <!--  -->
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <!--  -->
              <div class="bg-white rounded px-8 flex flex-col">
                <!--  -->
                <div class="mb-3">
                  <!--  -->
                  <div class="w-full flex-1 svelte-1l8159u">
                    <!--  -->
                    <label class="font-bold h-6 mt-3 text-gray-800 text-xs leading-8 uppercase">
                      <!--  -->
                      {{ $t('reason_for_cancellation') }}
                      <!--  -->
                    </label>
                    <!--  -->
                    <div class="velte-1l8159u">
                      <!--  -->
                      <textarea id="commentCancelled" cols="10" rows="3" :placeholder="$t('comment_hint')" v-model="shipping.comment" class="my-2 p-1 shadow appearance-none border-2 border-gray-500 rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="flex space-x-2 mt-3">
                    <!--  -->
                    <button @click="ChangeShippingStatus(order, 'cancelled')" :disabled="loading" class="w-full mt-2 bg-orange-600 focus:outline-none rounded-md hover:bg-orange-500 text-white font-semibold p-3">
                      <!--  -->
                      {{ $t("confirm") }}
                      <!--  -->
                    </button>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2 name="myModal" :headerOptions="{ title: $t('add_products') }" :noFooter="true" modalSize="lg" @on-close="closePopUp">
            <!--  -->
            <div class="flex flex-col w-full h-auto p-5 pt-0 mb-12">
              <!--  -->
              <div class="flex w-full h-auto justify-center items-center">
                <!--  -->
                <div class="flex mb-2 w-full h-auto py-2 justify-center items-center text-2xl font-bold">
                  <!--  -->
                  <span class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex">
                    <!--  -->
                    <input type="search" name="search" v-model="searchText" placeholder="Search" class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none" />
                    <!--  -->
                    <i class="material-icons text-orange-400 m-2 mr-5 text-lg w-4 h-4">search</i>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div>
                <!--  -->
                <div v-if="products.length <= 0" class="py-2">
                  <!--  -->
                  <span class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base">
                    <!--  -->
                    <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                      <!--  -->
                      <span class=""> {{ $t('no_products_found') }}</span>
                      <!--  -->
                    </p>
                    <!--  -->
                  </span>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-for="(item, index) in resultSearchProducts" :key="index" :value="item._id" class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-300 mb-2">
                  <!--  -->
                  <div>
                    <!--  -->
                    <input type="checkbox" :class="'product-' + index" class="form-checkbox checkallbbox mt-6 h-5 w-5 text-orange-500 border-orange-500" @change="addProductsToTemp(item, index)" v-model="item.check" />
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div>
                    <!--  -->
                    <img :alt="item.name" :src="item.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg' " class="h-16 w-16 rounded-md mx-auto" />
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="w-full">
                    
                    <!--  -->
                    <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
                    <!--  -->
                    <p class="text-gray-600 text-xs">
                      {{ exceptDes(item.description) }}
                    </p>
                    <!--  -->
                    <p v-if="item.variantes && item.variantes.length > 0">
                      <!--  -->
                      <v-select label="name" placeholder="Sélectionnez variante ..." :disabled="item.check" v-model="item.source" :options="item.variantes" @input="selectAutoVariant(item, index)" class="border border-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"></v-select>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="modal-footer px-5 border0-t text-right">
              <!--  -->
              <button @click="closePopUp" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
                {{ $t('cancel') }}
              </button>
              <!--  -->

              <!--  -->
              <button @click="ConfirmOperation" class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-orange-500 py-2 px-8 items-center focus:outline-none md:float-right">
                {{ $t('confirm') }}
              </button>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->

          <!--  -->
          <vue-modal-2  name="upsell" :headerOptions="{title: `Product: ${upsell.product}`}" :noFooter="true" modalSize="lg" @onclose="closeModal('upsell')">
            <div class="bg-white rounded-lg">
                <div class="bg-white px-8 mt-4 pb-1 mb-20">
                    <div class="vstack gap-2"> 
                        <div  v-for="(upsel, index) in upsell.upsells" :key="index" @click="activate(upsel)" :class="{active: upsell.activeUpsel && upsell.activeUpsel._id && upsell.activeUpsel._id.toString() === upsel._id.toString()?true:false}" class="form-check card-radio zoom-in intro-y">
                            <label class="form-check-label" for="listGroupRadioGrid1"> 
                                <div class="flex items-center">
                                    <div class="flex-shrink-0">
                                        <div class="avatar-xs">
                                            <div class="avatar-title bg-success-subtle text-success fs-18 rounded">
                                              <img class="h-8 w-8 rounded-full object-cover mx-1" src="https://img.icons8.com/stickers/100/sale-price-tag.png" alt="avatar">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1 ml-3">
                                        <h6 class="mb-1">Quantity: {{ upsel.quantity }}</h6>
                                        <b class="pay-amount">Prix: {{ upsel.price }} <sup v-if="idWharhouse">{{idWharhouse.currency}}</sup></b>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer px-5 border0-t text-right">
                    <div  @click="closeModal('upsell')" class="flex text-white cursor-pointer mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right" :class="loadingUpdateOrder?'noselect':''">Fermer</div>
                    <div @click="UpdateOrder(false, 'upsell')" class="flex text-white cursor-pointer mx-auto max-w-sm rounded text-center bg-green-500 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative mr-5" :class="loadingUpdateOrder?'noselect':''"><loading :active.sync="loadingUpdateOrder" :is-full-page="fullPage"></loading>Enregister Upsel</div>
                </div>
            </div>
          </vue-modal-2> 
          <!--  -->

          <!--  -->
          <vue-modal-2 name="validateCity" :headerOptions="{ title: $t('validate_city') }" :noFooter="true" modalSize="md" @on-close="closeModal('validateCity')">
            <!--  -->
            <div v-if="validateCity" class="flex flex-col w-full h-auto p-5 pt-0 mb-12">
              <!--  -->
              <div class="flex w-full h-auto justify-center items-center">
                <!--  -->
                <div class="flex mb-2 w-full h-auto py-2 justify-center items-center">
                  <!--  -->
                  <span v-if="validateCity.message" class="text-base text-red-400"> {{ validateCity.message }}</span>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="modal-footer px-5 border0-t text-right">
              <!--  -->
              <button @click="closeModal('validateCity')" class="flex text-white mx-auto max-w-sm rounded text-center bg-orange-500 py-2 px-8 items-center focus:outline-none md:float-right">
                <!--  -->
                <svg class="inline mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3.994 12.964l3.106 3.105-4.112.931 1.006-4.036zm9.994-3.764l-5.84 5.921-3.202-3.202 5.841-5.919 3.201 3.2z" fill="currentColor"/>
                </svg>
                <!--  -->
                <span> {{ $t('edit') }} </span>
                <!--  -->
              </button>
              <!--  -->
            </div>
            <!--  -->
          </vue-modal-2>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
</template>
<!--  -->

<script>
var Timer = require("easytimer.js").Timer;
var timer = new Timer();
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const PNF = require('google-libphonenumber').PhoneNumberFormat;

export default {
  data() {
    return {
      zones: [],
      courier: [],
      loading: false,
      fullPage: false,
      shipping: {
        date: this.getCurrentDate(),
        zone: null,
        courrier: null,
        comment: ""
      },
      limit: 10,
      statusOrder: [],
      currentUser: {},
      order: [{
        customer: {},
        details: [],
        seller: {},
        teleConsultant: {},
        skippedBy: [],
        unreachedBy: [],
      }],
      showButtonStart: true,
      vShow: false,
      orderFound: false,
      finished: false,
      style: false,
      sec: 0,
      min: 0,
      hr: 0,
      passedTime: "",
      time: 0,
      m: 0,
      s: 0,
      h: 0,
      dateDebut: "",
      cities: [],
      zeroH: false,
      zeroM: false,
      zeroS: false,
      motifAnnulation: "",
      reasonUnreached: "",
      contentRemend: "",
      contentSkipped: "",
      currency: "",
      remindDate: this.getCurrentDate(),
      loadingUpdateOrder: false,
      comments: ['Not interested-changed mind', "Didn't order", "Fake phone number", "Too expensive", "Non delivery area", "Out of country", "Mistake", "Bad comments", "Multiple order"],
      commentsUnreached: ["Boite vocale", "Ne répond pas", "Or ligne"],
      idWharhouse: null,
      loadingDouble: false,
      dataDouble: [],
      checkWarehouseParent: [],
      minDate: this.getCurrentDate(),
      newShippingDate: this.getCurrentDate(),
      searchText: '',
      products: [],
      calculate: [],
      selectedProduct: [],
      numberItemRepeated: 0,
      upsell:{
        product:"",
        upsells:[],
        activeUpsel:{}
      },
      validateCity: null,
    }
  },
  async mounted() {
    await this.getUser();
    this.token = this.$jwtService.verifyToken();
    if (this.currentUser && (this.currentUser.type != 'TeleConsultant' && this.currentUser.type != 'NRP' && this.currentUser.type != 'CancelledOrder' && this.currentUser.type != 'ToRemind')) this.$router.back();
    await this.getwharhouseId();
    await this.getStatus();
    await this.getZones();
    await this.getCouriers();
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
    resultSearchProducts() {
      if (!this.searchText) return this.products;

      const regex = new RegExp(this.searchText, 'i');
      
      return this.products.filter(product => 
        [product.name, product.code, product.code1, product.code2].some(field => regex.test(field))
      );
    }
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {
      await this.getwharhouseId();
      await this.getZones();
      await this.getCouriers();
    },
  },
  methods: {
    async openModal(name, product=null, upsells=[]){
      this.$vm2.open(name);
      if (name == 'myModalConfirm') {
        await this.getCities(this.order.customer.country);
      } 
      if(name === 'upsell'){
        this.upsell={product:product,upsells:upsells,activeUpsel:{}}
      } 
    },
    async closeModal(name) {
      this.$vm2.close(name);
      this.upsell={product:"",upsells:[],activeUpsel:{}}
    },
    checkUpselExist(product){
      let upselExist=false
      const checkUpsel=product.details.find(item => item.warehouse && item.warehouse && item.warehouse.toString() === this.idWharhouse._id.toString())
      if(checkUpsel && checkUpsel.upsells && checkUpsel.upsells.length>0){
        upselExist=checkUpsel.upsells;
      } 
      return upselExist;
    },
    activate(upsel){
      console.log('this==============>',upsel)
      this.upsell.activeUpsel=upsel;
      console.log("activate activeUpsel --------", this.upsell.activeUpsel)
    },
    closePopUp() {
      this.$vm2.close('myModal');
    },
    exceptDes(text) {
      return text && text.length > 60 ? text.substring(0, 60) + '...' : text;
    },
    async getOrder(country) {
      try {
        const dateNow = new Date().toLocaleString('en-US', { hour12: false }).replace(',', '');

        const data = await this.$server.confirmation("orders", { country, dateNow });

        if (data && data.content) {
          this.orderFound = true;
          this.order = data.content;
          this.order.date = this.$moment(this.order.date).format('yyyy-MM-DD HH:mm');
          this.calculate = this.order.details.map(detail => ({
            price: detail.unitPrice * detail.quantity,
            type: 'total',
          }));
        } else {
          this.order = [{
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
            unreachedBy: []
          }];
          this.orderFound = false;
          this.finished = true;
        }
      } catch (error) {
        console.error('Error fetching order:', error);
        this.orderFound = false;
        this.finished = true;
      }
    },
    async OpenPopUp() {
      if (!this.order.seller) return;

      await this.getProducts({});

      if (this.products.length > 0) {
        this.$vm2.open('myModal');
      } else {
        const message = this.currentUser.type !== 'Seller' 
          ? this.$t('no_products_seller')
          : this.$t('no_product_added');
        alert(message, 'warning');
      }
    },
    async getProducts() {
      if (!this.order.seller) {
        alert(this.$t('must_select_seller'), 'warning');
        return;
      }

      try {
        const warehouseId = this.idWharhouse && this.idWharhouse._id ? this.idWharhouse._id : null;

        const filters = {
          seller: this.order.seller._id,
          'details.warehouse': warehouseId,
          limit: 1000,
        };

        const res = await this.$server.search('products', filters);

        if (res && res.content && res.content.results) {

          this.products = res.content.results;

          this.products.forEach(product => {
            product.seller = product.seller._id || null;
            product.source = null;

            const warehouseDetails = this.getElementInArray(
              product.details.filter(detail => detail.warehouse),
              warehouseId
            );

            if (warehouseDetails) {
              product.price = warehouseDetails.price || 0;

              if (warehouseDetails.variantes && warehouseDetails.variantes.length > 0) {
                product.variantes = warehouseDetails.variantes.map(variant => ({
                  id: variant.id,
                  name: variant.name,
                  picture: variant.picture,
                }));
              }
            }
          });
        } else {
          this.products = [];
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        alert(this.$t('error_fetching_products'), 'error');
      }
    },
    selectAutoVariant(data, id) {
      data.check = true;
      let column = document.querySelector('.product-' + id);
      column.checked = true;
      this.addProductsToTemp(data, id);
    },
    addProductsToTemp(data, id) {
      if (data.check) {
        if (data.isPack && Array.isArray(data.packs) && data.packs.length > 0) {
          const totalPrice = this.order.details.reduce(
            (total, { unitPrice }) => total + unitPrice,
            0
          );

          const totalQuantity = this.order.details.reduce(
            (total, { quantity }) => total + quantity,
            0
          );

          const totalPacks = data.packs.reduce(
            (total, { unitPrice }) => total + unitPrice,
            0
          );

          if (totalPrice && totalPacks !== totalPrice) {
            const adjustmentRatio = totalPrice / totalPacks;

            data.packs.forEach(pack => {
              pack.unitPrice = +(pack.unitPrice * adjustmentRatio).toFixed(2);
              pack.quantity = totalQuantity;
            });
          }

          this.selectedProduct.push(...data.packs);

          return;
        }

        if (data.variantes && data.variantes.length > 0 && !data.source) {
          this.$toast.warning('Svp sélectionner une variante');
          data.check = false;

          const column = document.querySelector('.product-' + id);
          if (column) column.checked = false;
          return false;
        }

        const detail = {
          product: data,
          unitPrice: 0,
          quantity: 1,
          category: data.category ? data.category._id : null,
        };

        const isProductRepeated = this.order.details.some(detailItem => {
          const isSameProduct = detailItem.product._id === data._id;
          const hasSameSource = !detailItem.product.source && !data.source ||
            (detailItem.product.source && data.source && detailItem.product.source.id === data.source.id) ||
            (detailItem.variante && detailItem.variante.id === data.source.id);

          if (isSameProduct && hasSameSource) {
            this.numberItemRepeated++;
            return true;
          }
          return false;
        });

        if (!isProductRepeated) {
          this.selectedProduct.push(detail);
        }

      } else {
        const pos = this.selectedProduct.findIndex(e => e.product._id === data._id);
        if (pos !== -1) this.selectedProduct.splice(pos, 1);
        this.$nextTick(() => { this.$forceUpdate(); });
      }
    },
    ConfirmOperation() {
      this.order.details.push(...this.selectedProduct);
      this.calculate.push(
        ...this.selectedProduct.map(() => ({ price: 0, type: 'total' }))
      );

      this.order.details.forEach((_, index) => {
        this.calculateQtePrice(index, this.calculate[index].type);
      });

      this.selectedProduct = [];

      if (this.numberItemRepeated > 0) {
        alert(this.$t('product_already_added'), 'success');
      }

      this.numberItemRepeated = 0;
      this.$vm2.close('myModal');
    },
    removeProduct(data) {
      if (this.order.details.length > 1) {
        this.$confirm(this.$t('confirm_delete_product')).then(async () => {
          const productIndex = this.order.details.findIndex(
            o => o.product._id === data.product._id
          );

          if (productIndex !== -1) {
            this.order.details.splice(productIndex, 1);
            this.calculate.splice(productIndex, 1);
          }

          data.product.check = false;

          alert(this.$t('product_deleted'), 'success');
        });
      } else {
        alert(this.$t('Cannot Delete Last Product'), 'warning');
      }
    },
    addQuantity(index) {
      const item = this.order.details[index];
      item.quantity++;
      this.calculateQtePrice(index, this.calculate[index].type);
    },
    removeQuantity(index) {
      const item = this.order.details[index];
      if (item.quantity >= 1) {
        item.quantity--;
        this.calculateQtePrice(index, this.calculate[index].type);
      }
    },
    calculateQtePrice(index, type) {
      const item = this.order.details[index];
      if (type === 'total') {
        this.calculate[index].type = 'total';
        this.calculate[index].price = (item.unitPrice * item.quantity).toFixed(2);
      } else if (type === 'price' && item.quantity > 0) {
        this.calculate[index].type = 'price';
        item.unitPrice = this.calculate[index].price / item.quantity;
      }
    },
    TotalPrice() {
      let Total = 0;
      for (const element of this.order.details) {
        Total += element.unitPrice * element.quantity;
      }
      this.order.totalPrice = Total;
      return Total;
    },
    async UpdateOrder(check = true, name= null) {
      try {
        if(check) {
          const confirmUpdate = await this.$confirm(this.$t('Confirm Update Order'));
          if (!confirmUpdate) return;
        }

        if (name === 'upsell' && this.upsell.activeUpsel._id) {
          const activeUpsellId = this.upsell.activeUpsel._id.toString();
          const warehouseId = this.idWharhouse._id.toString();

          const index = this.order.details.findIndex(detail => 
            detail.product.details.some(item => 
              item.warehouse.toString() === warehouseId &&
              item.upsells.some(upsell => upsell._id.toString() === activeUpsellId)
            )
          );

          if (index !== -1) {
            const activeUpsell = this.upsell.activeUpsel;
            this.order.details[index].unitPrice = activeUpsell.price / activeUpsell.quantity;
            this.order.details[index].quantity = activeUpsell.quantity;
            this.calculateQtePrice(index, 'total')
          }
        } else if (name === 'upsell') {
          this.$toast.warning("SVP choisir un Pack Upsell");
          return false;
        }

        const productPromises = this.order.details.map(orderLine => 
          this.$server.get("products", { _id: orderLine.product._id })
        );

        const products = await Promise.all(productPromises);

        for (let index = 0; index < products.length; index++) {
          const product = products[index];
          let dataWhrahouse = this.getElementInArray(product.content.details, this.idWharhouse._id);

          const productDetails = this.order.details[index].product;

          const variantes = productDetails && productDetails.variantes ? productDetails.variantes : null;
          const source = productDetails && productDetails.source ? productDetails.source : null;

          if (variantes && variantes.length > 0 && !source) {
            return alert(`Svp sélectionner une variante dans ce produit: ${productDetails.name}`, 'warning');
          }

          if (variantes && variantes.length > 0 && source) {
            this.order.details[index].variante = source;
          }

          //check varainte exist in order element
          if (this.order.details[index].variante && this.order.details[index].variante.id) {
            const dataVariante = dataWhrahouse.variantes.find((el) => el.id === this.order.details[index].variante.id,);
            if (dataVariante) dataWhrahouse = dataVariante;
          }

          // Dont Delete This Gestion Quantity De Stock
          // if (dataWhrahouse && (dataWhrahouse.outOfStock || (dataWhrahouse.quantity && dataWhrahouse.quantity.inStock < 1))) {
          //   return alert(`Quantité en stock insuffisante pour ce produit: ${productDetails.name} !!`, "warning");
          // }
        }

        this.loadingUpdateOrder = true;
        this.order.totalPrice = this.SumTotalPrice(this.order.details);

        await this.$server.update("orders", this.order);

        if(check) {
          alert(this.$t('Order Updated Successfully'), 'success');
        }

      } catch (error) {
        console.error("Error updating order:", error);
        alert(this.$t('Error updating order. Please try again.'), 'error');
      } finally {
        this.closeModal(name);
        this.loadingUpdateOrder = false;
      }
    },
    getElementInArray(data, value) {
      return data.find(o => (o.warehouse._id || o.warehouse) === value.toString()) || null;
    },
    async ChangeShippingStatus(data, status) {
      try {
        const confirmed = await this.$confirm(`Are you sure you want to change the order status to ${status}?`);
        if (!confirmed) return;

        this.loading = true;

        const dataRepro = { status, _id: data._id };

        if (status === 'unreachable') {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          tomorrow.setHours(7, 32, 0, 0);
          dataRepro.date = tomorrow;
        } else if (['interested', 'reprogram'].includes(status)) {
          dataRepro.date = this.newShippingDate || this.shipping.date;
        } else if (status === 'cancelled') {
          dataRepro.comment = this.shipping.comment || '';
        }

        // Call API to change status
        const change = await this.$server.changeReprogrammedStatus("orders", dataRepro);

        if (change) {
          this.$alert(this.$t("Order updated"), "success");
          this.refreshData("Order updated", "success");
        }
      } catch (error) {
        console.error("Error in ChangeShippingStatus:", error);
        this.$alert(this.$t("Failed to update order"), "error");
      } finally {
        this.newShippingDate = this.getCurrentDate();
        this.loading = false;
      }
    },
    getCurrentDate() {
      return this.$moment().utcOffset(60).format('yyyy-MM-DDTHH:mm');
    },
    openWhatsApp() {
      let tel = phoneUtil.parse(this.order.customer.phone, this.order.customer.country);
      tel = phoneUtil.format(tel, PNF.E164);
      if (tel) {
        const whatsappLink = `whatsapp://send?phone=${tel}`;
        window.open(whatsappLink, '_blank');
      } else {
        return alert(`Invalid phone number: ${this.order.customer.phone}`, "warning");
      }
    },
    move(event) {
      var x = event.clientX;
      var y = event.clientY;

      var circle = document.querySelector('.circle');
      var circle2 = document.querySelector('.circle2');
      var circle3 = document.querySelector('.circle3');
      var square = document.querySelector('.square');
      var square2 = document.querySelector('.square2');

      if (circle) {
        circle.style.right = (3 + (x - window.innerWidth / 2) / 600) + '%';
      }
      if (circle2) {
        circle2.style.right = (20 + (x - window.innerWidth / 2) / 600) + '%';
      }
      if (circle3) {
        circle3.style.right = (35 + (x - window.innerWidth / 2) / 600) + '%';
      }
      if (square) {
        square.style.left = (45 + (x - window.innerWidth / 2) / 900) + '%';
      }
      if (square2) {
        square2.style.left = (15 + (x - window.innerWidth / 2) / 900) + '%';
      }
    },
    sumProduct(data) {
      let product = "";
      for (let i in data) {
        if (data[i].product && data[i].product.name) product += data[i].product.name
        if (data.length - 1 != i) product += " ,";
      }
      return product;
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId', { country: await this.warhouseSelected }).then((res) => {
        this.idWharhouse = res;
      })
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
        this.currency = res;
      })
    },
    SumTotalPrice(data) {
      let total = 0;
      for (let i in data) {
        total += data[i].quantity * data[i].unitPrice;
      }
      return total;
    },
    async getCities(country) {
      const resCities = await this.$server.get("zones", { allCities: true, country: country });
      if (resCities && resCities.content.length > 0) this.cities = resCities.content;
      else this.cities = [];
    },
    CalculateTime() {
      this.passedTime = timer.getTimeValues().toString();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async startConfirmation() {
      this.upsell={product:"",upsells:[],activeUpsel:{}}
      this.loading = true;
      const country = await this.warhouseSelected;
      await this.getOrder(country);
      this.loading = false;

      if (this.orderFound) {
        timer.reset();
        timer.start();

        timer.addEventListener('secondsUpdated', function (e) {
          $('#gettingValuesExample .hours').html(('0' + timer.getTimeValues().hours).slice(-2));
          $('#gettingValuesExample .minutes').html(('0' + timer.getTimeValues().minutes).slice(-2));
          $('#gettingValuesExample .seconds').html(('0' + timer.getTimeValues().seconds).slice(-2));
        });

        document.body.style.overflow = 'inherit'

        this.showButtonStart = false;
        this.sec = 0;
        this.min = 0;
        this.hr = 0;
        const nDate = new Date().toLocaleString('en-US', { timeZone: 'Africa/Casablanca' });
        let newdate = new Date(nDate)
        this.dateDebut = new Date();
      } else {
        alert(this.$t('no_order_to_confirm'), "warning");
      }
    },
    async getZones() {
      const res = await this.$server.search("zones", { limit: 2000, country: await this.warhouseSelected });
      if (res.content.results) this.zones = res.content.results;
      else this.zones = [];
    },
    async getCouriers() {
      const filter = {
        type: "Courier",
        countries: await this.warhouseSelected,
        limit: this.limit
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) {
        this.courier = res.content.results;
      } else this.courier = [];
    },
    async getStatus() {
      const res = await this.$server.search("status");
      if (res.content.results) this.statusOrder = res.content.results;
      else this.statusOrder = [];
    },
    async getStatusByName(name) {
      const result = await this.$server.get("status", { name: name });
      return result.content;
    },
    async ConfirmOrderStatus(dataToEdit, checkParent = null) {
      this.loading = true;

      // Save Product
      await this.UpdateOrder(false);

      // Check City
      if (!dataToEdit.customer.city) {
        alert(`City obligatoire`, 'warning');
        this.loading = false;
        return false;
      }

      // Check Validate City
      const checkCity = await this.$server.checkValidateCity('orders', { city: dataToEdit.customer.city });
      if (checkCity.invalid) {
        this.validateCity = checkCity;
        this.openModal("validateCity");
        this.loading = false;
        return false;
      }

      let id = await this.getStatusByName("Confirmed");
      dataToEdit.status = id;
      dataToEdit.statusCallcenter = id;

      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);

      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.teleConsultantConfirm = this.currentUser._id;

      if ( this.shipping.date && this.order._id) {
        const datashipping = {
          address: this.order.customer.shippingAddress,
          country: this.order.customer.country,
          date: this.shipping.date,
          order: this.order._id,
          seller: this.order.seller._id,
          totalPrice: this.order.totalPrice,
          status: "to prepare",
        };
        dataToEdit.shipping = datashipping;

        dataToEdit.Confirmation = true;
        const data = await this.$server.update("orders", dataToEdit);
        this.loading = false;

        if (data && data._id) {
          this.$vm2.close('warehouseParent');
          alert(this.$t('order_confirmed'), "success");
          dataToEdit = {};
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
          };
          this.shipping = {};
          this.shipping.date= this.getCurrentDate();
          this.showButtonStart = true;
          this.vShow = true;
        } else {
          await this.$server.update("orders", { _id: this.order._id, teleConsultant: null, onlyCommentedit: true });
          this.refreshData(data.message_1 || data, "warning")
        }
      } else {
        alert(this.$t('all_required_field'), "warning");
      }
    },
    async skipOrder(dataToEdit, name) {
      this.$confirm(`Are You sure to change order to A ${name} ?`).then(async (res) => {
        if (res) {
          this.CalculateTime();
          dataToEdit.comment = this.contentSkipped;
          dataToEdit.timeConsumed = this.passedTime;
          dataToEdit.time = parseInt(this.time);
          dataToEdit.dateDebut = this.dateDebut;
          dataToEdit.teleConsultant = null;

          dataToEdit[name.replace(/\s/g, '')] = true;
          const data = await this.$server.update("orders", dataToEdit);
          if (data && data._id) {
            this.refreshData('Order updated', "success")
          } else {
            await this.$server.update("orders", { _id: this.order._id, teleConsultant: null, onlyCommentedit: true });
            this.refreshData(data, "warning");
          }
        }
      });
    },
    async RemindOrder(dataToEdit) {
      this.loading = true;
      dataToEdit.comment = this.contentRemend;

      dataToEdit.remind = this.remindDate;
      this.CalculateTime();

      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);

      dataToEdit.dateDebut = this.dateDebut;
      const element = {
        user: this.currentUser._id,
      };

      dataToEdit.remindBy.push(element);
      dataToEdit.reminded = true;

      dataToEdit.lastUnreachedDate = null;
      dataToEdit.teleConsultant = null;
      
      if (!this.remindDate) {
        alert(this.$t('reminder_date_empty'), "warning");
        this.loading = false;
        return false;
      }

      const data = await this.$server.update("orders", dataToEdit);
      this.loading = false;

      if (data && data._id) {
        alert(this.$t('order_reminded'), "success");
        this.remindDate = this.getCurrentDate();
        this.contentRemend = "";
        dataToEdit = {};
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          remindBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
      } else {
        await this.$server.update("orders", { _id: this.order._id, onlyCommentedit: true });
        dataToEdit = {};
        this.remindDate = this.getCurrentDate();
        this.contentRemend = "";
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          remindBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
        alert(data, "warning");
      }
    },
    async cancelOrder(dataToEdit) {
      this.loading = true;
      const nDate = new Date().toLocaleString('en-US', { timeZone: 'Africa/Casablanca' });
      let newdate = new Date(nDate)
      let id = await this.getStatusByName("Cancelled");
      dataToEdit.status = id;
      dataToEdit.statusCallcenter = id;
      dataToEdit.motifAnnulation = this.motifAnnulation;
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.teleConsultantConfirm = this.currentUser._id;
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.comment = this.motifAnnulation;
      dataToEdit.teleConsultant = null;
      if (!this.motifAnnulation) {
        this.loading = false;
        alert(this.$t('reason_cancelled_required'), "warning");
        return false
      }
      if (this.currentUser.type == 'CancelledOrder') dataToEdit.validated_status = newdate;
      dataToEdit.cancelOrder = true;
      const data = await this.$server.update("orders", dataToEdit);
      this.loading = false;
      if (data && data._id) {
        this.motifAnnulation = "";
        alert(this.$t('order_cancelled'), "success");
        dataToEdit = {};
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
      } else {
        await this.$server.update("orders", { _id: this.order._id, teleConsultant: null, onlyCommentedit: true });
        alert(data, 'warning')
      }
    },
    async UnreachedOrder(dataToEdit) {
      this.loading = true;
      let id = await this.getStatusByName("Unreached");
      const nDate = new Date().toLocaleString('en-US', { timeZone: 'Africa/Casablanca' });
      let newdate = new Date(nDate)
      dataToEdit.unreached = id;
      dataToEdit.teleConsultant = null;
      dataToEdit.lastUnreachedDate = newdate;

      if (dataToEdit.remind) {
        dataToEdit.remind = null;
        dataToEdit.isReminded = false;
      }
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.comment = this.reasonUnreached;
      dataToEdit.dateUnrash = newdate;
      delete dataToEdit.updateStartDate;
      if (!this.reasonUnreached) {
        alert(this.$t('reason_unreached_required'), "warning");
        return false
      }
      dataToEdit.pending_unrached = true;
      const data = await this.$server.update("orders", dataToEdit);
      this.loading = false;
      if (data && data._id) {
        alert(this.$t('order_unreached'), "success");
        this.reasonUnreached = "";
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
      } else {
        await this.$server.update("orders", { _id: this.order._id, teleConsultant: null, onlyCommentedit: true });
        alert(data, "warning");
        this.reasonUnreached = "";
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        this.showButtonStart = true;
        this.vShow = true;
      }
    },
    refreshData(message, type) {
      alert(message, type);
      this.reasonUnreached = "";
      this.motifAnnulation = "";
      this.contentSkipped = "";
      this.remindDate = this.getCurrentDate();
      this.showButtonStart = true;
      this.vShow = true;
      this.order = {
        customer: {},
        details: [],
        seller: {},
        teleConsultant: {},
        skippedBy: [],
        unreachedBy: [],
      };
      this.shipping = {}
      this.shipping.date= this.getCurrentDate();
    },
    ChronoStart() {
      if (this.sec < 60) {
        this.s = setTimeout(() => {
          this.sec += 1;
          this.ChronoStart();
        }, 1000);
        this.remettreAZero();
      } else if (this.min == 60) {
        this.hr += 1;
        this.min = 0;
        this.h = setTimeout(() => {
          this.sec += 1;
          this.ChronoStart();
        }, 1000);
        this.remettreAZero();
      } else {
        this.min += 1;
        this.sec = 0;
        this.m = setTimeout(() => {
          this.sec += 1;
          this.ChronoStart();
        }, 1000);
        this.remettreAZero();
      }
    },
    remettreAZero() {
      if (this.sec < 10) {
        this.zeroS = true;
      } else {
        this.zeroS = false;
      }
      if (this.min < 10) {
        this.zeroM = true;
      } else {
        this.zeroM = false;
      }
      if (this.hr < 10) {
        this.zeroH = true;
      } else {
        this.zeroH = false;
      }
    },
  },
};
</script>


<style scoped>
.card-radio .form-check-label {
  background-color: #fff;
  border: 1px solid #e7eaec;
  border-radius: .25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
  cursor: pointer;
  margin-bottom: 0;
  font-weight: 400;
  background-image: linear-gradient(109.6deg, rgba(223, 234, 247, 1) 11.2%, rgba(244, 248, 252, 1) 91.1%);
}

.card-radio .form-check-label {
  white-space: nowrap;
}

.vstack {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-item-align: stretch;
  align-self: stretch;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #6691e7;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 400;
  height: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100%;
}

.fs-18 {
  font-size: 18px !important;
}

.text-success {
  --vz-text-opacity: 1;
  color: rgba(19,197,107,1) !important;
}

.bg-success-subtle {
  background-color: #f4f8fc !important;
}

.tab-confirm {
  position: relative;
  z-index: 1;
}

.tab-confirm:after {
  position: absolute;
  content: '';
  height: 100%;
  width: 100%;
  background: linear-gradient(45deg,
  rgb(253, 253, 253),
  rgb(223, 229, 234),
  rgb(255, 255, 255));
  background-size: 200% 200%;
  background-position: 0% 100%;
  animation-name: test_hover;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
  z-index: -1;
}

@keyframes test_hover {
  from {
    background-position: 0% 100%;
  }

  to {
    background-position: 100% 0%;
  }
}

.btn-marketing {
  -webkit-animation: shadow-pulse 1s infinite;
  animation: shadow-pulse 1s infinite;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(30, 112, 185);
  }

  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}

.vm2_wrapper {
  z-index: 11;
}

.phone {
  background-color: #e8bc52;
  border-color: #e8bc52;
  color: #fff !important;
  display: inline-block;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  padding: 2px;
}

.box-3 {
  background-image: linear-gradient(109.6deg, rgba(223, 234, 247, 1) 11.2%, rgba(244, 248, 252, 1) 91.1%);
}

.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}

.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

.badge-soft-success {
  color: #e8bc52;
  background-color: rgba(232, 188, 82, 0.1);
  display: inline-block;
  padding: 2px 2px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 10px;
}

.card-1 {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-image: linear-gradient(to top, #fff1eb 0%, #ace0f9 100%);
  border: 1px solid #63b3ed;
}

.card-header-1:first-child {
  border-radius: 0.25rem 0.25rem 0 0;
}

.card-header-1 {
  border-bottom: 1px solid #e9ebec;
}

.card-header-1 {
  padding: 0.8em 1rem;
  margin-bottom: 0;
  background-color: #fff;
}

.card-title {
  font-size: 17px;
}

h5 {
  font-weight: 600;
  line-height: 1.2;
}

.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important;
}

@-moz-keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }

  100% {
    -moz-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}

@-webkit-keyframes facebookSpinner {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}

@keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }

  100% {
    -moz-transform: scale(0.7, 0.7);
    -ms-transform: scale(0.7, 0.7);
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}

.facebook-spinner {
  width: 25px;
  height: 28px;
  display: inline-block;
  vertical-align: middle;
}

.facebook-spinner .spinner-block {
  float: left;
  width: 7px;
  height: 28px;
  background-color: #8b9dc3;
  border: 1px solid #3b5998;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-animation-name: facebookSpinner;
  -webkit-animation-name: facebookSpinner;
  animation-name: facebookSpinner;
  -moz-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -moz-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.facebook-spinner .spinner-block:not(:last-child) {
  margin-right: 2px;
}

.facebook-spinner .block-1 {
  -moz-animation-delay: 100ms;
  -webkit-animation-delay: 100ms;
  animation-delay: 100ms;
}

.facebook-spinner .block-2 {
  -moz-animation-delay: 200ms;
  -webkit-animation-delay: 200ms;
  animation-delay: 200ms;
}

.facebook-spinner .block-3 {
  -moz-animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
  animation-delay: 300ms;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.align-middle {
  vertical-align: middle !important;
}

.card-body-1 {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.maxx-heigh {
  max-height: 50px;
  overflow-y: scroll;
}

.icon::after {
  content: '';
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #19a69d;
  left: 100%;
  top: 0;
}

.v-select {
  width: 100%;
}

.vs__dropdown-toggle {
  border: none;
}

dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.label {
  transition: all 0.2s ease-out;
  top: 0.4rem;
  left: 0;
}

.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;
}

.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;

  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}

.flip-clock__slot {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
  color: #78a5ed;
}

.flip-card {
  display: block;
  position: relative;
  padding-bottom: 0.1em;
  font-size: 2.25rem;
  line-height: 0.95;
}

@media (min-width: 1000px) {
  .flip-clock__slot {
    font-size: 1.2rem;
  }

  .flip-card {
    font-size: 3rem;
  }
}

.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: 1.44em;
  color: #E8E9EB;
  background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
  padding: 0.23em 0.25em 0.4em;
  border-radius: 0.15em 0.15em 0.15em 0.15em;
  transform-style: preserve-3d;
  width: 1.8em;
}

.flip-card__bottom,
.flip-card__back-bottom {
  color: #fff;
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 0.15em 0.15em;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}

.flip-card__back-bottom {
  z-index: 1;
}

.flip-card__bottom::after,
.flip-card__back-bottom::after {
  display: block;
  margin-top: -0.72em;
}

.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after {
  content: attr(data-value);
}

.flip-card__back {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}

.flip-card__back::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.flip .flip-card__back::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(0.37, 0.01, 0.94, 0.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}

.flip .flip-card__bottom {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(0.15, 0.45, 0.28, 1);
}

.icon-call {
  font-size: 40px;
}

@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }

  0%,
  99% {
    opacity: 1;
  }

  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}

@keyframes flipBottom {

  0%,
  50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }

  51% {
    opacity: 1;
  }

  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}

.ath_container {
  position: relative;
  height: 95vh;
  background-color: #ededed;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content_col {
  width: 90%;
  max-width: 100%;
}

.content_col h2 {
  line-height: 40px;
  font-size: 34px;
}

.content_col p {
  line-height: 18px;
}

.circle {
  position: absolute;
  top: 30px;
  right: 3%;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.3);
  animation: circleAnimation 10s ease-in-out infinite;
  z-index: 1;
}

.circle2 {
  position: absolute;
  bottom: 300px;
  right: 20%;
  transform: translateX(-50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.2);
  animation: circle2Animation 12s ease-in-out infinite;
  z-index: 1;
}

.circle3 {
  position: absolute;
  bottom: 100px;
  right: 35%;
  transform: translateX(-50%);
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: rgba(255, 0, 0, 0.25);
  animation: circle3Animation 15s ease-in-out infinite;
  z-index: 1;
}

.square {
  position: absolute;
  top: 200px;
  left: 45%;
  transform: translateX(-50%) rotate(45deg);
  width: 75px;
  height: 75px;
  border: 2px solid rgba(255, 0, 0, 0.3);
  border-radius: 5px;
  animation: squareAnimation 8s ease-in-out infinite;
  z-index: 1;
}

.square2 {
  position: absolute;
  bottom: 150px;
  left: 15%;
  transform: translateX(-30%) rotate(45deg);
  width: 40px;
  height: 40px;
  border: 2px solid rgba(255, 0, 0, 0.5);
  border-radius: 5px;
  transform: rotate(90);
  animation: square2Animation 14s ease-in-out infinite;
  z-index: 1;
}

@keyframes circleAnimation {
  0% {
    transform: translate(-0%, 2%);
  }

  50% {
    transform: translate(-20%, 100px);
  }

  100% {
    transform: translate(-0%, 2%);
  }
}

@keyframes circle2Animation {
  0% {
    transform: translate(-40%, 0);
  }

  50% {
    transform: translate(-40%, 120px);
  }

  100% {
    transform: translate(-40%, 0);
  }
}

@keyframes circle3Animation {
  0% {
    transform: translate(-40%, 0);
  }

  50% {
    transform: translate(-40%, 80px);
  }

  100% {
    transform: translate(-40%, 0);
  }
}

@keyframes squareAnimation {
  0% {
    transform: translate(-50%, 0) rotate(45deg);
  }

  50% {
    transform: translate(-50%, -100px) rotate(45deg);
  }

  100% {
    transform: translate(-50%, 0) rotate(45deg);
  }
}

@keyframes square2Animation {
  0% {
    transform: translate(-30%, 0) rotate(45deg);
  }

  50% {
    transform: translate(-30%, -70px) rotate(45deg);
  }

  100% {
    transform: translate(-30%, 0) rotate(45deg);
  }
}
</style>
